import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Pipe({ name: 'convertUTCtoESTDate' })
export class ConvertUTCtoESTDatePipe implements PipeTransform {
    constructor(
        private router: Router,
      ) {}

    public transform(input: string): string {
        //Eastern Standard Time (EST) is 5 hours behind Coordinated Universal Time (UTC
        const url = this.router.url;
        if(input){
            let newDate;
            if(this.router.url.includes('/history')){
                newDate = moment.utc(input).subtract(5, 'hours').format("MM-DD-YYYY");
            }else{
                newDate = moment.utc(input).subtract(5, 'hours').format("MM/DD/YYYY");
            }
            return newDate;
        }
        return '';
    }
}